import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

const AiModels = lazy(() => import('./AiModels').then((module) => ({ default: module.AiModels })));

class AiModelsWebComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['self-service-flag'];
    }

    render() {
        const selfServiceFeatureFlagEnabled = this.prop('self-service-flag') === 'true';

        return (
            <AiModels
                isCreateUserProfilesEnabled={selfServiceFeatureFlagEnabled}
                isDeleteUserProfilesEnabled={selfServiceFeatureFlagEnabled}
            />
        );
    }
}

customElements.define('ai-models-component', AiModelsWebComponent);
